<span (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
  @if (displayL && iconVisible) {
    <span class="m-l-5" (click)="copyValue()"
      ><b><fa-icon icon="copy" size="sm" title="{{ 'labels.text.Copy Account Number' | translate }}"></fa-icon></b
    ></span>
  }
  @if (accountType) {
    <span class="m-l-5">
      <a href="{{ getAccountLink() }}">{{ accountNo }}</a>
    </span>
  }
  @if (!accountType) {
    <span class="m-l-5">{{ accountNo }}</span>
  }
  @if (displayR && iconVisible) {
    <span class="m-l-3" (click)="copyValue()"
      ><b><fa-icon icon="copy" size="sm" title="{{ 'labels.text.Copy Account Number' | translate }}"></fa-icon></b
    ></span>
  }
</span>
